import React from "react";

/* Logotipo propio de Natur Blur: cuadrado degradado naranja→ámbar
   con un círculo mitad nítido / mitad pixelado (motivo privacidad). */
const Logo = ({ size = 40, dark = false }) => (
  <span className="inline-flex items-center gap-2.5 select-none">
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
      <defs>
        <linearGradient id="nb-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#FFB81C" />
          <stop offset="1" stopColor="#F26F21" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="44" height="44" rx="14" fill="url(#nb-grad)" />
      <path d="M24 11.5a12.5 12.5 0 0 0 0 25Z" fill="#FFFFFF" />
      <rect x="26" y="12.5" width="5" height="5" rx="1.6" fill="#FFFFFF" opacity="0.95" />
      <rect x="32.5" y="16.5" width="4" height="4" rx="1.4" fill="#FFFFFF" opacity="0.65" />
      <rect x="27" y="20.5" width="5" height="5" rx="1.6" fill="#FFFFFF" opacity="0.85" />
      <rect x="33.5" y="23.5" width="3.6" height="3.6" rx="1.3" fill="#FFFFFF" opacity="0.45" />
      <rect x="26.5" y="28.5" width="4.6" height="4.6" rx="1.5" fill="#FFFFFF" opacity="0.7" />
      <rect x="32" y="30.5" width="3.2" height="3.2" rx="1.2" fill="#FFFFFF" opacity="0.35" />
    </svg>
    <span className="leading-none">
      <span className={`font-display italic font-extrabold text-[21px] tracking-tight block ${dark ? "text-white" : "text-[#241E18]"}`}>
        Natur <span className="text-[#F26F21]">Blur</span>
      </span>
      <span className={`text-[10px] font-semibold tracking-[0.18em] uppercase ${dark ? "text-white/50" : "text-[#A69C90]"}`}>
        Privacidad en vídeo
      </span>
    </span>
  </span>
);

export default Logo;
